/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.4.0
 * @since 1.0.0
 */

import { memo } from 'react';

import { IconStyled } from './styled/IconStyled';

interface IIconProps {
    className?: string;
    dataName?: string;
    icon: string | string[];
    size: number;
}

const Icon = (props: IIconProps) => (
    Array.isArray(props.icon)
        ? <div>
            {
                props.icon.map((src: string) =>
                    <IconStyled
                        className={props.className}
                        data-icon={props.dataName}
                        key={src}
                        size={props.size}
                        src={src}
                    />,
                )
            }
        </div>
        : <IconStyled
            className={props.className}
            data-icon={props.dataName}
            size={props.size}
            src={props.icon}
        />
);

export default memo(Icon);
